module.exports = __webpack_public_path__ + "static/media/Annual_Report_2020.c7c9a4e5.pdf";